// export const setTarget = () => {
//     const link = document.querySelectorAll(".newsList__article");
//
//     link.forEach(el => {
//         const target = el.dataset.target;
//         if (target) {
//             el.setAttribute("target", target);
//             el.removeAttribute("data-target");
//         }
//     });
// };
function deactivateTab(tabs) {
    Array.prototype.forEach.call(tabs, function(item) {
        item.classList.remove("active");
    });
}

function sortingItems(sortValue) {
    let items = document.querySelectorAll("[data-sorting]");

    if (!items) {
        return;
    }

    Array.prototype.forEach.call(items, function(item) {
        let itemValue = item.getAttribute("data-sorting");

        if (sortValue === "all") {
            item.classList.add("visible");
            return;
        }

        if (sortValue !== itemValue) {
            item.classList.remove("visible");
        } else {
            item.classList.add("visible");
        }
    });
}

function smartTabs() {
    let tabsContainer = document.querySelector(".sorting-wrp");
    let tabsWrp = document.querySelector(".smartNewsList__tabs");

    if (tabsContainer && tabsContainer.classList.contains("hidden")) {
        return;
    }

    if (tabsWrp) {
        let tabsItem = tabsWrp.querySelectorAll("li");
        Array.prototype.forEach.call(tabsItem, function(item) {
            item.addEventListener("click", function(e) {
                e.preventDefault();

                if (item.classList.contains("active")) {
                    return;
                }

                let dataValue = item.getAttribute("data-smart-tab");
                deactivateTab(tabsItem);
                this.classList.add("active");

                sortingItems(dataValue);
            });
        });
    }
}

function init() {
    smartTabs();
}

export default { init };
